import {PropsWithChildren, ReactNode} from 'react';
import {useAppSelector} from '@hooks/app';
import {useGetUserProfileQuery} from '../pages/Profile/Profile.api';

export const HasAccess = ({children, def = <div/>}: PropsWithChildren<{def?: ReactNode | string}>) => {
    const {token} = useAppSelector(state => state.app);
    const {data, isError} = useGetUserProfileQuery({token: token});

    return <>
        {!!data && children}
        {!data && def}
    </>;
};
